import { List, Map } from 'immutable';
import createSelector from '../../utils/reselect';

const getTimeAndExpense = (state: any) => {
    const { timeAndExpense } = state;
    return timeAndExpense || Map();
};

export const getTimeSheetList = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetList', 'data']) ?? List();
});

export const getTimeSheetLoading = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetList', 'loading']) || false;
});

export const getLoadMore = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetList', 'loadMore']);
});

export const getTimeSheetCount = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetList', 'timeSheetCount']) || Map();
});

export const getFilteredTimeSheetListLoading = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetList', 'filterLoading']) || false;
});

export const getTimeSheetCategoriesLoadingStatus = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetCategories', 'loading']);
});

export const getExpenseCategoriesLoadingStatus = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetExpenseCategories', 'loading']);
});

export const getTimeSheetCategories = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetCategories', 'data']);
});

export const getExpenseCategories = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetExpenseCategories', 'data']) ?? List();
});

export const getTimeSheetSelectedDate = createSelector(getTimeAndExpense, (state) => {
    return state.get('selectedDate');
});

export const getTimeSheetAppointments = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetAppointments', 'data']);
});

export const getTimeSheetAppointmentsLoadingStatus = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetAppointments', 'loading']);
});

export const getTimeSheetType = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetType', 'data']) ?? List();
});

export const getTimeSheetStartDate = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheet', 'data', 'startDate']);
});

export const getTimeSheetDetail = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheet', 'data']) ?? Map();
});

export const getTimeSheetId = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheet', 'data', 'id']);
});

export const getTimeSheetEndDate = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheet', 'data', 'endDate']);
});

export const getTimeSheetStatus = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheet', 'data', 'status']);
});

export const getLocationFormDetails = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetType', 'editForm']);
});

export const getAddTimeSheetCommentLoader = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetComment', 'loading']);
});

export const getTimeSheetCommentList = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetComment', 'data']) || List();
});

export const getTimeSheetCommentListLoader = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetComment', 'loading']);
});

export const getTimeSheetDetailLoadingStatus = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheet', 'loading']);
});

// Get Timesheet pack loading from time & expense screen
export const getTimesheetPackLoading = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['templates', 'loading']);
});

export const getTimesheetSearchForm = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetSearchForm', 'data']);
});

export const getTimesheetSearchFormLoadingStatus = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetSearchForm', 'loading']);
});

export const getTimeSheetFilterSelections = createSelector(getTimeAndExpense, (state) => {
    return state.getIn(['timeSheetList', 'filterSelections']);
});
